var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs-docs"},[_c('AppIframe',{key:_vm.src,ref:"frame",attrs:{"loading-text":"Loading Knowledge Base","src":_vm.iframeSrc,"iframe-height":_vm.iframeHeight},on:{"load":_vm.handleLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }